import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { selectIsLoggedIn, selectRecovery } from 'containers/Login/loginSlice'
import useSwitchAccount from 'hooks/useSwitchAccount'
import { useSelector } from 'react-redux'

const WarningPopup = ({ mail = false, goToLoginForm, close }) => {
  const { t } = useTranslation('form')
  const { replace } = useHistory()
  const recovery = useSelector(selectRecovery)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const { switchAccount, isPending } = useSwitchAccount()
  // token odzyskiwania dotyczy danych, które właśnie okazały się zajęte (telefon albo e-mail)
  const canRecover = !!recovery?.token && (mail ? !!recovery.login?.email : !!recovery.login?.phone)

  return (
    <Popup close={close}>
      <div className='popup__verification'>
        <i className='icon icon--logo s24' />
        <p>{t(mail ? 'emailHasAlreadyBeenUsed' : 'phoneNumberHasAlreadyBeenUsed')} {t('wouldYouLikeToLogInInstead')}</p>
        <div className='verification__buttons'>
          <ArrowBtn
            enlarged
            text={t('logIn')}
            isLoading={isPending}
            action={() => {
              if (isLoggedIn) switchAccount('/login')
              else if (goToLoginForm) goToLoginForm()
              else replace('/login')
            }}
          />
          {canRecover && <ArrowBtn
            enlarged
            showArrow={false}
            className='--black'
            text={t('recoverAccess')}
            action={() => {
              if (isLoggedIn) switchAccount('/login/recovery', { recoveryLogin: recovery.login })
              else replace('/login/recovery')
            }}
          />}
          <BackBtn
            text={t('continue')}
            action={() => !isPending && close()}
          />
        </div>
      </div>
    </Popup>
  )
}

export default WarningPopup